import { array, string, object } from "prop-types";
import Icon from "../Icon/Icon.jsx";

const propTypes = {
  logo: string,
  title: string,
  summary: string,
  authors: string,
  organization: string,
  link: string.isRequired,
  dictionaryData: object.isRequired,
};

const PartnerModal = (props) => {
  const {
    logo,
    title,
    summary,
    authors,
    organization,
    link,
    dictionaryData,
  } = props;

  return (
    <section className="partner-modal">
      {logo && (
        <div className="partner-modal__logo">
          <img src={logo} alt="logo" />
        </div>
      )}
      {title && <div className="partner-modal__title">{title}</div>}
      {summary && (
        <div
          className="partner-modal__summary"
          dangerouslySetInnerHTML={{ __html: summary }}
        ></div>
      )}
      {(authors.length > 0 || organization) && (
        <div className="partner-modal__sources">
          {authors.length > 0 && (
            <div>
              <div className="partner-modal__source-label">
                {dictionaryData.authors}
              </div>
              <div
                className="partner-modal__source-text"
                dangerouslySetInnerHTML={{ __html: authors }}
              ></div>
            </div>
          )}
          {organization && (
            <div>
              <div className="partner-modal__source-label">
                {dictionaryData.institutionalAffiliations}
              </div>
              <div className="partner-modal__source-text">{organization}</div>
            </div>
          )}
        </div>
      )}
      <div className="partner-modal__link-wrapper">
        <a
          href={link}
          target="_blank"
          className="partner-modal__link btn btn--tertiary-ghost"
          aria-label={`${dictionaryData.visitCaseStudy} - ${title}`}
        >
          {dictionaryData.visitCaseStudy}
          <span className="btn__icon">
            <svg
              className="icon icon--arrow-right"
              role="img"
              width="18"
              height="16"
              viewBox="0 0 18 16"
              xmlns="http://www.w3.org/2000/svg"
            >
              <g fill="none" fillRule="evenodd">
                <path
                  d="M16.665 7.693c.07.072.133.152.176.242a1.097 1.097 0 01.009 1.122c-.045.088-.106.17-.175.251l-5.363 5.463a.752.752 0 01-1.08 0 .775.775 0 010-1.104L15.276 8.5l-5.046-5.168a.774.774 0 010-1.103.752.752 0 011.08 0l5.354 5.464z"
                  fill="currentcolor"
                />
                <path
                  d="M15.5 8.5h-11"
                  stroke="currentcolor"
                  strokeWidth="1.5"
                  strokeLinecap="round"
                />
              </g>
            </svg>
          </span>
        </a>
      </div>
    </section>
  );
};

PartnerModal.propTypes = propTypes;
export default PartnerModal;
